import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import Sidebar from '../Sidebar'
import Header from '../Header'
import HeaderFilters from '../HeaderFilters';

import { GiPoliceOfficerHead } from "react-icons/gi";
import { MdCheck, MdLock, MdWhatsapp  } from "react-icons/md";

import { API_BASE } from '../../config/api';

import ReactApexChart from 'react-apexcharts';

function NoticiasSuperLider() {
const [admin, setAdmin] = useState(null);
const [loadingAdmin, setLoadingAdmin] = useState(true);

useEffect(() => {
    const fetchAdmin = async () => {
        try {
            setLoadingAdmin(true);

            const res = await fetch(`${API_BASE}/api/admin/me`, {
                method: "GET",
                credentials: "include",
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "No se pudo obtener la información del admin");
            }

            setAdmin(data.data);
        } catch (error) {
            console.error("Error al obtener admin:", error);
            setAdmin(null);
        } finally {
            setLoadingAdmin(false);
        }
    };

    fetchAdmin();
}, []);

// Panel General
    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState("");

    const [distys, setDistys] = useState([]);
    const [grados, setGrados] = useState([]);

    const [distyId, setDistyId] = useState("");
    const [gradoId, setGradoId] = useState("");

    const [startDate, setStartDate] = useState("2026-05-11");
    const [endDate, setEndDate] = useState("2026-11-30");

    const [downloadingExcel, setDownloadingExcel] = useState(false);

    const [summary, setSummary] = useState({
        usuariosRegistrados: 0,
        usuariosActivos: 0,
        usuariosNoActivos: 0,
        usuariosBorrados: 0,
        usuariosMexico: 0,
        usuariosLatam: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [filtersReady, setFiltersReady] = useState(false);

const [loadingNoticias, setLoadingNoticias] = useState(false);

const [noticiasData, setNoticiasData] = useState({
    resumenGeneral: {
        totalPublicaciones: 0,
        clicksTotales: 0,
        clicksUnicos: 0,
    },
    slider: {
        totalPublicaciones: 0,
        clicksTotales: 0,
        clicksUnicos: 0,
        publicaciones: [],
        tendenciaPublicaciones: {
            categories: [],
            series: [],
        },
        distysResumen: [],
    },
    carrusel: {
        totalPublicaciones: 0,
        clicksTotales: 0,
        clicksUnicos: 0,
        publicaciones: [],
        tendenciaPublicaciones: {
            categories: [],
            series: [],
        },
        distysResumen: [],
    },
    eventos: {
        disponible: false,
        message: "",
        totalPublicaciones: 0,
        clicksTotales: 0,
        clicksUnicos: 0,
        publicaciones: [],
        tendenciaPublicaciones: {
            categories: [],
            series: [],
        },
        distysResumen: [],
    },
});

const handleRegionChange = async (value) => {
    setRegionId(value);
    setDistyId("");
    setGradoId("");

    await getFilters({
        nextRegionId: value,
        nextDistyId: "",
    });
};

const handleDistyChange = async (value) => {
    setDistyId(value);
    setGradoId("");

    await getFilters({
        nextRegionId: regionId,
        nextDistyId: value,
        updateRegions: false,
        updateDistys: false,
        updateGrados: true,
    });
};;

const handleGradoChange = (value) => {
    setGradoId(value);
};

    // =============================
    // Cargar filtros iniciales
    // =============================

const getFilters = async ({
    nextRegionId = "",
    nextDistyId = "",
    updateRegions = true,
    updateDistys = true,
    updateGrados = true,
} = {}) => {
    try {
        const params = new URLSearchParams();

        if (nextRegionId) params.append("regionId", nextRegionId);
        if (nextDistyId) params.append("distyId", nextDistyId);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(result.message || "Error al obtener filtros.");
        }

        if (updateRegions) {
            setRegions(result.data?.regions || []);
        }

        if (updateDistys) {
            setDistys(result.data?.distys || []);
        }

        if (updateGrados) {
            setGrados(result.data?.grados || []);
        }

        return result.data;
    } catch (error) {
        console.error("Error filtros HomeSuperLider:", error);
        setError(error.message);
        return null;
    }
};

useEffect(() => {
    const initFilters = async () => {
        try {
            const data = await getFilters({
                updateRegions: true,
                updateDistys: true,
                updateGrados: true,
            });

            const defaultRegionId = String(data?.defaultRegionId || "");

            setRegionId(defaultRegionId);
            setDistyId("");
            setGradoId("");

            setStartDate(data?.defaultStartDate || "2026-05-11");
            setEndDate(data?.defaultEndDate || "2026-11-30");

            if (defaultRegionId) {
                await getFilters({
                    nextRegionId: defaultRegionId,
                    nextDistyId: "",
                    updateRegions: false,
                    updateDistys: true,
                    updateGrados: true,
                });
            }
        } catch (error) {
            console.error("Error al inicializar filtros:", error);
        } finally {
            setFiltersReady(true);
        }
    };

    initFilters();
}, []);

const getNoticiasSuperLider = async () => {
    try {
        setLoadingNoticias(true);
        setError("");

        const params = new URLSearchParams();

        if (regionId) params.append("regionId", regionId);
        if (distyId) params.append("distyId", distyId);
        if (gradoId) params.append("gradoId", gradoId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/superlider-noticias?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.ok) {
            throw new Error(result.message || "Error al obtener datos de noticias.");
        }

        setNoticiasData({
            resumenGeneral: result.data?.resumenGeneral || {
                totalPublicaciones: 0,
                clicksTotales: 0,
                clicksUnicos: 0,
            },
            slider: result.data?.slider || {
                totalPublicaciones: 0,
                clicksTotales: 0,
                clicksUnicos: 0,
                publicaciones: [],
                tendenciaPublicaciones: {
                    categories: [],
                    series: [],
                },
                distysResumen: [],
            },
            carrusel: result.data?.carrusel || {
                totalPublicaciones: 0,
                clicksTotales: 0,
                clicksUnicos: 0,
                publicaciones: [],
                tendenciaPublicaciones: {
                    categories: [],
                    series: [],
                },
                distysResumen: [],
            },
            eventos: result.data?.eventos || {
                disponible: false,
                message: "",
                totalPublicaciones: 0,
                clicksTotales: 0,
                clicksUnicos: 0,
                publicaciones: [],
                tendenciaPublicaciones: {
                    categories: [],
                    series: [],
                },
                distysResumen: [],
            },
        });
    } catch (error) {
        console.error("Error noticias Super Líder:", error);
        setError(error.message);
    } finally {
        setLoadingNoticias(false);
    }
};

useEffect(() => {
    if (!filtersReady) return;

    getNoticiasSuperLider();
}, [
    filtersReady,
    regionId,
    distyId,
    gradoId,
    startDate,
    endDate,
]);

const downloadNoticiasExcel = async (section = "todo") => {
    try {
        setDownloadingExcel(true);
        setError("");

        const params = new URLSearchParams();

        params.append("section", section);

        if (regionId) params.append("regionId", regionId);
        if (distyId) params.append("distyId", distyId);
        if (gradoId) params.append("gradoId", gradoId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/superlider-noticias-excel?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        if (!response.ok) {
            throw new Error("No se pudo descargar el reporte.");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `reporte_clicks_${section}.xlsx`;
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error al descargar Excel noticias:", error);
        setError(error.message);
    } finally {
        setDownloadingExcel(false);
    }
};

const buildNoticiasTrendOptions = (categories = []) => ({
    chart: {
        type: "line",
        stacked: false,
        toolbar: {
            show: true,
        },
        zoom: {
            enabled: true,
        },
    },
    stroke: {
        width: [0, 4],
        curve: "smooth",
    },
    plotOptions: {
        bar: {
            columnWidth: "45%",
        },
    },
    dataLabels: {
        enabled: false,
    },
    xaxis: {
        categories,
        labels: {
            rotate: -45,
            trim: true,
            style: {
                fontSize: "11px",
            },
        },
    },
    yaxis: [
        {
            title: {
                text: "Clicks totales",
            },
        },
        {
            opposite: true,
            title: {
                text: "Clicks únicos",
            },
        },
    ],
    tooltip: {
        shared: true,
        intersect: false,
    },
    legend: {
        position: "bottom",
    },
    colors: ["#2196F3", "#20B486"],
});

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
                
                <HeaderFilters
                    title="Datos Noticias"
                    subtitle="Panel Super Líder"

                    regions={regions}
                    distys={distys}
                    grados={grados}

                    regionId={regionId}
                    distyId={distyId}
                    gradoId={gradoId}

                    startDate={startDate}
                    endDate={endDate}

                    onRegionChange={handleRegionChange}
                    onDistyChange={handleDistyChange}
                    onGradoChange={handleGradoChange}
                    onStartDateChange={setStartDate}
                    onEndDateChange={setEndDate}
                />

                {error && (
    <div className="alert alert-danger mt-3" role="alert">
        {error}
    </div>
)}

<NoticiasSection
    title="Slider"
    section="slider"
    data={noticiasData.slider}
    loading={loadingNoticias}
    downloadingExcel={downloadingExcel}
    onDownloadExcel={downloadNoticiasExcel}
    buildChartOptions={buildNoticiasTrendOptions}
/>

<NoticiasSection
    title="Carrusel"
    section="carrusel"
    data={noticiasData.carrusel}
    loading={loadingNoticias}
    downloadingExcel={downloadingExcel}
    onDownloadExcel={downloadNoticiasExcel}
    buildChartOptions={buildNoticiasTrendOptions}
/>

            </div>
        </main>
        </>
    )
}

const NoticiasSection = ({
    title,
    section,
    data,
    loading,
    downloadingExcel,
    onDownloadExcel,
    buildChartOptions,
}) => {
    const [showDetails, setShowDetails] = useState(false);

    const chartOptions = useMemo(
        () => buildChartOptions(data?.tendenciaPublicaciones?.categories || []),
        [data?.tendenciaPublicaciones?.categories, buildChartOptions]
    );

    const chartSeries = useMemo(() => {
        const sourceSeries = data?.tendenciaPublicaciones?.series || [];

        return sourceSeries.map((serie, index) => ({
            ...serie,
            type: index === 0 ? "column" : "line",
        }));
    }, [data?.tendenciaPublicaciones?.series]);

    return (
        <div className="row mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">{title}</h5>

                <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    disabled={downloadingExcel}
                    onClick={() => onDownloadExcel(section)}
                >
                    {downloadingExcel ? "Descargando..." : "Descargar Excel"}
                </button>
            </div>

            {!showDetails ? (
                <>
                    <div className="col-lg-4">
                        <div class="card">
                            <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="bg-info text-white rounded p-3">
                                     <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.4" d="M16.6756 2H7.33333C3.92889 2 2 3.92889 2 7.33333V16.6667C2 20.0711 3.92889 22 7.33333 22H16.6756C20.08 22 22 20.0711 22 16.6667V7.33333C22 3.92889 20.08 2 16.6756 2Z" fill="currentColor"></path>
                                        <path d="M7.36866 9.3689C6.91533 9.3689 6.54199 9.74223 6.54199 10.2045V17.0756C6.54199 17.5289 6.91533 17.9022 7.36866 17.9022C7.83088 17.9022 8.20421 17.5289 8.20421 17.0756V10.2045C8.20421 9.74223 7.83088 9.3689 7.36866 9.3689Z" fill="currentColor"></path>
                                        <path d="M12.0352 6.08887C11.5818 6.08887 11.2085 6.4622 11.2085 6.92442V17.0755C11.2085 17.5289 11.5818 17.9022 12.0352 17.9022C12.4974 17.9022 12.8707 17.5289 12.8707 17.0755V6.92442C12.8707 6.4622 12.4974 6.08887 12.0352 6.08887Z" fill="currentColor"></path>
                                        <path d="M16.6398 12.9956C16.1775 12.9956 15.8042 13.3689 15.8042 13.8312V17.0756C15.8042 17.5289 16.1775 17.9023 16.6309 17.9023C17.0931 17.9023 17.4664 17.5289 17.4664 17.0756V13.8312C17.4664 13.3689 17.0931 12.9956 16.6398 12.9956Z" fill="currentColor"></path>
                                    </svg>
                                </div>
                                <div class="text-end">
                                    Publicaciones
                                        <h2 class="counter" style={{visibility: 'visible'}}>
                                            {loading
                                        ? "..."
                                        : Number(data?.totalPublicaciones || 0).toLocaleString("es-MX")}
                                        </h2>
                                </div>
                            </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div class="card border-bottom border-4 border-0 border-primary">
                                    <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <span>Clicks totales</span>
                                        </div>
                                        <div>
                                            <span>
                                                {loading
                                                ? "..."
                                                : Number(data?.clicksTotales || 0).toLocaleString("es-MX")}
                                            </span>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">

                                <div class="card border-bottom border-4 border-0 border-secondary">
                                    <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <span>Clicks únicos</span>
                                        </div>
                                        <div>
                                            <span>
                                                {loading
                                                ? "..."
                                                : Number(data?.clicksUnicos || 0).toLocaleString("es-MX")}
                                            </span>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => setShowDetails(true)}
                            >
                                Mostrar detalle
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="card h-100">
                            <div className="card-header">
                                <div className="header-title">
                                    <h4 className="card-title mb-0">
                                        Tendencia por publicación
                                    </h4>
                                </div>
                            </div>

                            <div className="card-body">
                                {loading ? (
                                    <p className="mb-0">Cargando gráfica...</p>
                                ) : !chartSeries.length ? (
                                    <p className="mb-0 text-muted">
                                        No hay datos para graficar.
                                    </p>
                                ) : (
                                    <ReactApexChart
                                        options={chartOptions}
                                        series={chartSeries}
                                        type="line"
                                        height={350}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="col-lg-3">
                        <div className="card">
                            <div className="card-body">
                                <p className="mb-1 text-muted">Publicaciones</p>

                                <h3 className="counter mb-0">
                                    {loading
                                        ? "..."
                                        : Number(data?.totalPublicaciones || 0).toLocaleString("es-MX")}
                                </h3>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <p className="mb-1 text-muted">Clicks totales</p>

                                <h3 className="counter mb-0">
                                    {loading
                                        ? "..."
                                        : Number(data?.clicksTotales || 0).toLocaleString("es-MX")}
                                </h3>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <p className="mb-1 text-muted">Clicks únicos</p>

                                <h3 className="counter mb-0">
                                    {loading
                                        ? "..."
                                        : Number(data?.clicksUnicos || 0).toLocaleString("es-MX")}
                                </h3>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm w-100"
                            onClick={() => setShowDetails(false)}
                        >
                            Volver a vista simple
                        </button>
                    </div>

                    <div className="col-lg-4">
                        <div className="card h-100">
                            <div className="card-header">
                                <div className="header-title">
                                    <h4 className="card-title mb-0">
                                        Usuarios únicos por disty
                                    </h4>
                                </div>
                            </div>

                            <div className="card-body">
                                {loading ? (
                                    <p className="mb-0">Cargando distys...</p>
                                ) : !data?.distysResumen?.length ? (
                                    <p className="mb-0 text-muted">
                                        No hay información de distys.
                                    </p>
                                ) : (
                                    <div
                                        className="table-responsive"
                                        style={{
                                            maxHeight: "390px",
                                            overflowY: "auto",
                                        }}
                                    >
                                        <table className="table table-sm align-middle mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Disty</th>
                                                    <th className="text-end">Usuarios únicos</th>
                                                    <th className="text-end">Clicks</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {data.distysResumen.map((disty) => (
                                                    <tr key={disty.distyId}>
                                                        <td>{disty.distyNombre}</td>
                                                        <td className="text-end">
                                                            {Number(disty.usuariosUnicos || 0).toLocaleString("es-MX")}
                                                        </td>
                                                        <td className="text-end">
                                                            {Number(disty.clicksTotales || 0).toLocaleString("es-MX")}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <div className="card h-100">
                            <div className="card-header">
                                <div className="header-title">
                                    <h4 className="card-title mb-0">
                                        Tendencia por publicación
                                    </h4>
                                </div>
                            </div>

                            <div className="card-body">
                                {loading ? (
                                    <p className="mb-0">Cargando gráfica...</p>
                                ) : !chartSeries.length ? (
                                    <p className="mb-0 text-muted">
                                        No hay datos para graficar.
                                    </p>
                                ) : (
                                    <ReactApexChart
                                        options={chartOptions}
                                        series={chartSeries}
                                        type="line"
                                        height={390}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default NoticiasSuperLider